import { z } from 'zod';
import { bankTransactionSchema } from './schemas';

/** POST /accounting/bank-transactions/import */
export const bankTransactionImportResponseSchema = z.object({
  success: z.literal(true),
  transactions: z.array(bankTransactionSchema),
});

/** POST /accounting/reconciliation/complete — bank account period marked reconciled (not company month-end close). */
export const reconciliationCompleteResponseSchema = z.object({
  success: z.literal(true),
  period: z.string().optional(),
  alreadyClosed: z.boolean().optional(),
  closedPeriodId: z.string().optional(),
});

export type BankTransactionImportResponse = z.infer<typeof bankTransactionImportResponseSchema>;
export type ReconciliationCompleteResponse = z.infer<typeof reconciliationCompleteResponseSchema>;
